export default {
  title: 'Crea link di onboarding',
  steps: {
    select_gateway: 'Seleziona gateway',
    copy_link: 'Copia link',
  },
  select_gateway: {
    description: 'Scegli il gateway di pagamento per cui vuoi generare un link di onboarding a lunga durata.',
  },
  link: {
    proxy_url_label: 'URL di onboarding',
    expires_label: 'Scade',
    copy_button: 'Copia URL',
    copied: 'Copiato!',
    description:
      'Condividi questo URL con il commerciante. Reindirizza alla pagina di onboarding del gateway e rimane valido fino alla data di scadenza.',
  },
  buttons: {
    next: 'Avanti',
    back: 'Indietro',
    done: 'Fatto',
  },
  toasts: {
    create_success: 'Link di onboarding creato con successo.',
    create_failed: 'Creazione del link di onboarding non riuscita.',
  },
};
